import { useContext, useMemo, useState } from "react";
import { Button, Col, Form, Spinner } from "react-bootstrap";
import { getByAuthService } from "../../../../../../function/helper";
import FactorContext from "../../context/FactorContext";
import discountSuccessResponse from "../../../functions/discountSuccessResponse";

function DiscountSection() {
  const { factorDetail, setFactorDetail } = useContext(FactorContext);

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const isCod = useMemo(() => {
    const find = factorDetail.shipments.find(element => element.item.isCod);
    return find ? 1 : 0;
  }, []);

  const validateDiscountCode = async value => {
    setResponseMessage("");
    if (value === "") {
      setResponseMessage("ابتدا کد تخفیف رو وارد کنید");
      return;
    }

    setLoading(true);
    const validity = await getByAuthService("/discount/v1/customer/check", {
      dc: value,
      company_id: factorDetail.companyId,
      isCod,
      ordersCount: factorDetail.shipments?.length,
    });
    setLoading(false);

    if (validity.status === 200) {
      setResponseMessage(
        discountSuccessResponse(
          validity.data.data.discount,
          factorDetail.shipments.reduce(
            (sum, { item }) => sum + item.realPayable,
            0
          )
        )
      );

      setFactorDetail(cur => ({
        ...cur,
        discountCode: validity.data.data.discount.id,
      }));
      return;
    }

    setFactorDetail(cur => ({
      ...cur,
      discountCode: 0,
    }));
    setResponseMessage(validity.message);
  };

  return (
    <section>
      <hr />
      <form
        onSubmit={e => {
          e.preventDefault();

          validateDiscountCode(e.target[0].value);
        }}
      >
        <div className="d-flex flex-wrap">
          <Col xs={12} md={6}>
            <Form.Control
              placeholder="چنانچه کد تخفیف دارید اینجا وارد کنید"
              className="d-inline-block"
              height={40}
            />
          </Col>

          <Col
            xs={12}
            md={6}
            className="d-flex align-items-center justify-content-end mt-2 mt-md-0"
          >
            {loading === true ? (
              <Button
                className="d-inline-block btn-success-style"
                type="button"
              >
                <div className="d-flex justify-content-evenly align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span>در حال بررسی</span>
                </div>
              </Button>
            ) : (
              <Button
                className="d-inline-block btn-success-style text-center"
                type="submit"
              >
                بررسی کد
              </Button>
            )}

            {responseMessage !== "" && factorDetail.discountCode !== 0 && (
              <Button
                className="btn-danger me-2"
                type="button"
                onClick={() => {
                  setFactorDetail(cur => ({
                    ...cur,
                    discountCode: 0,
                  }));
                  setResponseMessage("");
                }}
              >
                انصراف از تخفیف
              </Button>
            )}
          </Col>
        </div>
        <div
          className={
            factorDetail.discountCode > 0 ? "text-success" : "text-danger"
          }
          style={{ whiteSpace: "pre-line", direction: "rtl" }}
        >
          {responseMessage}
        </div>
      </form>
      <hr />
    </section>
  );
}

export default DiscountSection;
